module.exports = __webpack_public_path__ + "json/buildings-initial-0.json?8bc17cdb7150a9019f40e7ceb2ab98d7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings-initial/buildings-initial-0.json
// module id = 1730
// module chunks = 3